import { version } from "../package.json";
export const HOST_URL = "https://app.song.ru";

export const API_URL = `${HOST_URL}/api`;
export const SALT = "eyJpc3MiOiJodHRwczpcL1wvYXBwLnRl";

export const DELAY_BEFORE_LOADING_INDICATOR = 1000;

export const ITEMS_IN_SHOWCASE = 5;
export const ITEMS_IN_CHARTS = 10;
export const PAGINATION_PER_PAGE = 30;
export const PAGINATION_PAGE_RANGE = 2;

export const USER_GROUP_GUEST = 0;
export const USER_GROUP_PERSON = 1;
export const USER_GROUP_ARTIST = 2;

export const TRACKS_UPLOAD_TYPES_REGEXP = new RegExp(/mp3|mpeg$/i);
export const TRACK_UPLOAD_SIZE_LIMIT = 60 * 1024 * 1024; // 15mb
export const IMAGES_UPLOAD_TYPES_REGEXP = new RegExp(
  /\.(jpeg|jpe|jpg|gif|png|webp)$/i
);
export const IMAGE_UPLOAD_SIZE_LIMIT = 5 * 1024 * 1024; // 5mb
export const CURRENT_YEAR = new Date().getFullYear();

export const APP_VERSTION = version;
export const BREAKPOINS = {
  lg: 1599,
  xl: 1439,
  l: 1179,
  md: 959,
  m: 767,
  s: 559,
  xs: 320
};
